// src/overlayComponents/ModuleContainer.js
import React from 'react';
import { useTheme } from '../../themes/ThemeProvider';

const ModuleContainer = ({ children, className = '' }) => {
  const { theme, size } = useTheme();


  return (
    <div className={`${theme.container} ${size.container} mx-auto ${className} module_overlays`}>
      {children}
    </div>
  );
};

export default ModuleContainer;